module.exports = __webpack_public_path__ + "img/p4-tit.abae71df.png";